module.exports = __webpack_public_path__ + "static/thpcdinosaur1-a7a00f9a9398365e3ddabdec00f104d7.jpeg";